import { ExternalLink } from '@atlassian/mpac-ui';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const FAQKey = {
  SERVER_EOL_LICENSING_IMPACT: 'serverEolLicensingImpact',
  SERVER_EOL_INSTALL_ON_DC: 'serverEolInstallOnDc',
  SERVER_EOL_START_TRIAL: 'serverEolStartTrial',
  SERVER_EOL_PVP_PVA_AVAILABILITY: 'serverEolPvPPvAAvalailability'
};
export const getServerEolLicensingImpactFAQ = () => ({
  question: 'How will server app pricing and licensing be impacted post-end of sale and support for server apps?',
  key: FAQKey.SERVER_EOL_LICENSING_IMPACT,
  answer: /*#__PURE__*/_jsxs("p", {
    children: ["The maintenance end date for server apps sold through the Atlassian Marketplace will not extend beyond Feb 15, 2024. After this date, Atlassian will prevent the publishing of app updates or versions. The renewals of server apps will automatically be prorated until the end of support for server apps.", ' ', /*#__PURE__*/_jsx(ExternalLink, {
      href: "https://www.atlassian.com/migration/assess/journey-to-cloud",
      children: "Learn more about end of sale and support for server apps"
    })]
  })
});
export const getServerEOLStartTrialFAQ = serverEolStartDate => ({
  question: "Between ".concat(serverEolStartDate, ", and February 15, 2024, will customers be able to start trials for server apps?"),
  key: FAQKey.SERVER_EOL_START_TRIAL,
  answer: /*#__PURE__*/_jsxs("p", {
    children: ["The deadline to add new server apps to an existing server or Data Center instance is", ' ', serverEolStartDate, ". After this time, customers can't install new server apps or trials."]
  })
});
export const getServerEolInstallOnDCFAQ = () => ({
  question: 'What are the other alternatives available for this app?',
  key: FAQKey.SERVER_EOL_INSTALL_ON_DC,
  answer: /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: "If this app has a Data Center approved version, you can install the Data Center version of the app."
    }), /*#__PURE__*/_jsx(ExternalLink, {
      href: "https://www.atlassian.com/licensing/purchase-licensing",
      children: "Learn more about Data Center approved apps"
    })]
  })
});
export const getServerEOLAppAvailabilityFAQ = () => ({
  question: "What type of license do I need if I'm using this app in a Data Center product?",
  key: FAQKey.SERVER_EOL_PVP_PVA_AVAILABILITY,
  answer: /*#__PURE__*/_jsxs("p", {
    children: ["If this app has a Data Center approved version, you should purchase a Data Center license for the app.", /*#__PURE__*/_jsx(ExternalLink, {
      href: "https://www.atlassian.com/licensing/purchase-licensing",
      children: "Learn more about Data Center licensing"
    })]
  })
});
export default function getServerEolFAQs(serverEolStartDate) {
  return [getServerEolLicensingImpactFAQ(), getServerEOLStartTrialFAQ(serverEolStartDate), getServerEolInstallOnDCFAQ(), getServerEOLAppAvailabilityFAQ()];
}